import React from "react"
import styled from 'styled-components'
import { Button } from 'reactstrap'
import { FONTS, COLORS } from '../../../constants'

export default class SearchbarReport extends React.Component {
  render() {
    return (
      <Wrapper>
        <CustomButton
          bg={ COLORS.UPLOAD_COLOR }
          border={ COLORS.UPLOAD_COLOR_BORDER }
          onClick={ () => this.props.export(1) }
        >Export Active Users</CustomButton>
        <CustomButton
          bg={ COLORS.UPLOAD_COLOR }
          border={ COLORS.UPLOAD_COLOR_BORDER }
          onClick={ () => this.props.export(0) }
        >Export Audit Log</CustomButton>
      </Wrapper>
    )
  }
}

const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 150px;
  height: 30px;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const Wrapper = styled.div`
  background-color: #ffffff;  
  height: 40px;
  position: relative;
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`



// WEBPACK FOOTER //
// ./src/components/searchbar-report/audit-log/index.js